import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RaremarqBrandIdentityPage = lazy(() => import('../pages/raremarq-brand-identity/page'));
const RaremarqWebPlatformPage = lazy(() => import('../pages/raremarq-web-platform/page'));
const CGCIntegrationPage = lazy(() => import('../pages/cgc-integration/page'));
const HumanMarqAIPage = lazy(() => import('../pages/humanmarq-ai/page'));
const RekindlePage = lazy(() => import('../pages/rekindle/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/raremarq-brand-identity',
    element: <RaremarqBrandIdentityPage />,
  },
  {
    path: '/raremarq-web-platform',
    element: <RaremarqWebPlatformPage />,
  },
  {
    path: '/cgc-integration',
    element: <CGCIntegrationPage />,
  },
  {
    path: '/humanmarq-ai',
    element: <HumanMarqAIPage />,
  },
  {
    path: '/rekindle',
    element: <RekindlePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
